
import React from 'react';
import { useLocation } from 'react-router-dom';
import CoreMetaTags from './components/CoreMetaTags';
import SocialShareTags from './components/SocialShareTags';
import HreflangTags from './components/HreflangTags';
import PerformanceTags from './components/PerformanceTags';
import StructuredDataTags from './components/StructuredDataTags';
import { useStructuredData } from '@/hooks/useStructuredData';

interface SEOPageData {
  title: string;
  description: string;
  keywords: string;
  canonicalUrl: string;
  ogImage: string;
  ogType: 'website' | 'article';
  h1Title: string;
  geoData?: {
    latitude?: number;
    longitude?: number;
    region?: string;
    country?: string;
  };
  structuredData?: any[];
  author?: string;
  publishedTime?: string;
  modifiedTime?: string;
  noIndex?: boolean;
}

interface EnhancedSEOSystemProps {
  pageData: SEOPageData;
  pageType?: 'home' | 'city' | 'country' | 'therapist' | 'search' | 'static';
  entityData?: any; // City, Country, or Therapist data
}

const EnhancedSEOSystem: React.FC<EnhancedSEOSystemProps> = ({
  pageData,
  pageType = 'static',
  entityData
}) => {
  const location = useLocation();
  const baseUrl = 'https://psychotherapist.help';
  const currentUrl = `${baseUrl}${location.pathname}`;

  // Generate comprehensive structured data using the custom hook
  const structuredData = useStructuredData({
    pageType,
    entityData,
    pageData
  });

  return (
    <>
      <CoreMetaTags
        title={pageData.title}
        description={pageData.description}
        keywords={pageData.keywords}
        canonicalUrl={pageData.canonicalUrl || currentUrl}
        noIndex={pageData.noIndex}
        author={pageData.author}
        geoData={pageData.geoData}
      />
      
      <SocialShareTags
        title={pageData.title}
        description={pageData.description}
        ogType={pageData.ogType || 'website'}
        ogImage={pageData.ogImage || `${baseUrl}/og-image.png`}
        canonicalUrl={pageData.canonicalUrl || currentUrl}
        author={pageData.author}
        publishedTime={pageData.publishedTime}
        modifiedTime={pageData.modifiedTime}
      />
      
      <HreflangTags />
      
      <PerformanceTags />
      
      <StructuredDataTags structuredData={structuredData} />
    </>
  );
};

export default EnhancedSEOSystem;
